<template>
    <v-snackbar v-model="snackbar" color="primary" :timeout="timeout" class="pa-0" bottom right>
      <v-card color="primary" flat>
          <v-card-actions>
            {{ text }}
            <v-spacer></v-spacer>
            <v-icon color="white" @click="snackbar = false">close</v-icon>
        </v-card-actions>
      </v-card>
    </v-snackbar>
</template>

<script>
export default {
  props: ['text', 'show', 'timeout', 'isTarget'],
  data() {
    return {
      snackbar: this.show && this.isTarget
    }
  }
}
</script>
